import { overquotaNewUnsub } from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewUnsub';

export const enum Reasons {
    FREE_ENOUGH = 'Достаточно бесплатной версии',
    ANOTHER_CLOUD = 'Есть подписка на другое облако',
    TECH_PROBLEMS = 'Технические проблемы',
    OTHER_ID = 'Другое',
    ANOTHER_PRODUCT = 'Есть подписка на другой тариф',
    HIGH_PRICE = 'Высокая цена',
    POLL_DLG_ID = 'poll-dlg',
}

export const MAX_COMMENT_LENGTH = 200;

export const getReasons = (isPhone = false) => {
    if (overquotaNewUnsub) {
        return [
            Reasons.FREE_ENOUGH,
            isPhone ? Reasons.ANOTHER_PRODUCT : Reasons.HIGH_PRICE,
            isPhone ? Reasons.TECH_PROBLEMS : Reasons.ANOTHER_PRODUCT,
            isPhone ? Reasons.ANOTHER_CLOUD : Reasons.TECH_PROBLEMS,
            isPhone ? Reasons.HIGH_PRICE : Reasons.ANOTHER_CLOUD,
            Reasons.OTHER_ID,
        ];
    }

    return [
        Reasons.FREE_ENOUGH,
        Reasons.ANOTHER_CLOUD,
        Reasons.TECH_PROBLEMS,
        isPhone ? Reasons.ANOTHER_PRODUCT : Reasons.HIGH_PRICE,
        isPhone ? Reasons.HIGH_PRICE : Reasons.ANOTHER_PRODUCT,
        Reasons.OTHER_ID,
    ];
};
